export const siteConfig = {
  title: 'Bison Agents — SaaS AEO/GEO | Monitoreo de Visibilidad en IA para LatAm',
  description:
    'Plataforma integral de Answer Engine Optimization (AEO) y Generative Engine Optimization (GEO) para agencias y marcas en LatAm. Monitorea, optimiza y protege tu visibilidad en ChatGPT, Perplexity, Claude, Gemini y Google AI Overviews.',
  url: 'https://bisonagents.com',
  language: 'es-CL',
  schemaType: 'SoftwareApplication',
  ogTitle: 'Bison Agents — SaaS AEO/GEO | Monitoreo de Visibilidad en IA para LatAm',
  ogDescription:
    'Plataforma integral de Answer Engine Optimization (AEO) y Generative Engine Optimization (GEO) para agencias y marcas en LatAm. Monitorea, optimiza y protege tu visibilidad en ChatGPT, Perplexity, Claude, Gemini y Google AI Overviews.',
  ogImage: 'https://bisonagents.com/og-image.png',
  twitterHandle: '@bisonagents',
  gtmId: 'GTM-NJVZNZ2V',
  gaId: 'G-GQCWYM8LMH',
};
